import { create } from "zustand";
import { persist, PersistStorage } from "zustand/middleware";

interface AuthState {
    customer_idx: number | null;
    customer_name: string | null;
    setData: (data: Partial<AuthState>) => void;
    clearData: () => void;
}

const customStorage: PersistStorage<AuthState> = {
    getItem: name => {
        const item = localStorage.getItem(name);
        return item ? JSON.parse(item) : null;
    },
    setItem: (name, value) => {
        localStorage.setItem(name, JSON.stringify(value));
    },
    removeItem: name => {
        localStorage.removeItem(name);
    },
};

export const useNonMemberStore = create(
    persist<AuthState>(
        set => ({
            customer_idx: null,
            customer_name: null,
            setData: data => set(state => ({ ...state, ...data })),
            clearData: () =>
                set({
                    customer_idx: null,
                    customer_name: null,
                }),
        }),
        {
            name: "non-member-storage",
            storage: customStorage,
        },
    ),
);
